const leagueReducer = (state, action) => {

    switch (action.type) {
        case "CHANGE_LEAGUEACTIVE":
            return { 
                league: action.payload
                //leagues: state.leagues
            };
        case "CHANGE_RANKEDLIST":
            return { 
                rankedList: action.payload
                //leagues: state.leagues
            };
        /*
        case "ADD_LEAGUE":
            return {
                leagues: [...state.leagues, action.payload]
            };
            */
        /*case "LOAD_LEAGUES":
            return { 
                //leagueActive: state.leagueActive,
                leagues: action.payload 
            };*/
        default:
            //return state
            return { 
                //leagues: state.leagues,
                league: state.league,
                rankedList: state.rankedList
                //leagues: state.leagues
            }
    }
};
  
export default leagueReducer